var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "card flex-md-row" }, [
    _c(
      "div",
      {
        staticClass: "card-body d-flex flex-column align-items-start py-2 px-3",
      },
      [
        _c(
          "div",
          {
            staticClass:
              "d-flex flex-row align-items-center justify-content-start w-100",
          },
          [
            _c(
              "div",
              {
                staticClass: "d-flex flex-column justify-content-between mr-3",
              },
              [
                _c("span", { staticClass: "badge badge-primary mb-2" }, [
                  _vm._v(
                    "\n                    " +
                      _vm._s(_vm.order) +
                      "\n                "
                  ),
                ]),
                _vm._v(" "),
                _vm.service
                  ? _c(
                      "span",
                      { staticClass: "badge", class: _vm.classServiceCode },
                      [
                        _vm._v(
                          "\n                    " +
                            _vm._s(_vm.serviceCode) +
                            "\n                "
                        ),
                      ]
                    )
                  : _vm._e(),
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "w-100" }, [
              _c(
                "div",
                {
                  staticClass:
                    "d-flex flex-row align-items-center justify-content-between w-100 mb-1",
                },
                [
                  _c("strong", { staticClass: "d-inline-block text-info" }, [
                    _vm._v(
                      "\n                        " +
                        _vm._s(_vm.title) +
                        "\n                    "
                    ),
                  ]),
                  _vm._v(" "),
                  !_vm.readonlyForm
                    ? _c("i", {
                        staticClass: "cursor-pointer fa fa-times close",
                        on: {
                          click: function ($event) {
                            $event.preventDefault()
                            return _vm.removeResource.apply(null, arguments)
                          },
                        },
                      })
                    : _vm._e(),
                ]
              ),
              _vm._v(" "),
              _vm.name
                ? _c("p", { staticClass: "small mb-0" }, [
                    _vm._v(
                      "\n                    " +
                        _vm._s(_vm.name) +
                        "\n                "
                    ),
                  ])
                : _vm._e(),
            ]),
          ]
        ),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }